module.exports = __webpack_public_path__ + "static/media/location.bd2af0ea.svg";